import { Map } from 'ol';
import { Extent, buffer as bufferExtent } from 'ol/extent';

export const waitForMapToMoveEnd = (map: Map) =>
  new Promise((resolve) => {
    map.once('moveend', resolve);
  });

export const expandExtentByPixels = (
  map: Map,
  extent: Extent,
  pixels: number,
) => {
  const view = map.getView();
  const resolution = view.getResolution();

  if (!resolution) throw new Error('Не возможно получить разрешение карты');

  const buffer = pixels * resolution;

  return bufferExtent(extent, buffer);
};
